<template>
  <div class="content">
    <figure>
      <img src="@/assets/logo.png" id="logo" alt="Soul Match">
    </figure>
    <h1 class="title">速配｜來一場5分鐘的快速聊天</h1>
    <blockquote class="quote">Once you lose someone, it is never exactly the same person who comes back.</blockquote>
    <transition-group tag="div" class="content-inner" name="fade">
      <div class="message-wrapper" v-for="m in message" :key="m.time" :class="{
          right:m.who==='me',
          center:m.who==='system'
        }">
        <pre class="message" :class="{
            you:m.who==='you',
            me:m.who==='me',
            system:m.who==='system',
            boy:m.sex==='boy',
            girl:m.sex==='girl',
            success:m.state==='success'
          }">{{m.text}}<img @load="scrollMessageToBottom" class="message-img" v-if="m.image!==undefined" :src="m.image" alt="[圖]" /></pre>
      </div>
    </transition-group>
    <p class="button-parent" v-if="!$socket.connected">
      <button @click.once="socketInitial('Random')">隨機快聊</button>
      <transition name="seesaw">
        <button v-if="schoolExist===true" @click.once="sameSchool" class="button-school">{{schoolName}}</button>
      </transition>
      <button v-if="schoolExist===null" @click="querying" class="button-disabled">{{queryButton}}</button>
      <transition name="seesaw">
        <button v-if="schoolExist===false" @click.once="socketInitial($ls.get('information').city)">附近的人</button>
      </transition>
    </p>
    <p v-if="!$socket.connected" class="footer">
      認親就來
      <a class="social-media" href="https://www.facebook.com/soulmatch2018/" target="_blank">粉絲專頁</a>看看！ 偷偷說...使用學校IP有驚喜，點選 說明 查看支援學校！
    </p>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import throttle from 'lodash/throttle';
export default {
  data() {
    return {
      queryButton: '同校聊天'
    };
  },
  computed: {
    ...mapState('chat', ['message']),
    ...mapGetters('school', ['schoolExist', 'schoolName'])
  },
  methods: {
    querying: throttle(function() {
      this.queryButton = '偵測中...';
      this.getSchoolInfo()
        .then(() => {
          if (this.schoolExist) {
            this.$notify({
              group: 'foo',
              type: 'success',
              text: `${this.schoolName}的同學，您好！`
            });
          } else if (this.schoolExist === false) {
            this.$notify({
              group: 'foo',
              type: 'warn',
              text: '尚不支援，試試看附近的人？'
            });
          } else {
            this.$notify({
              group: 'foo',
              type: 'error',
              text: '請檢察網路狀態'
            });
          }
        })
        .finally(() => {
          this.queryButton = '同校聊天';
        });
    }, 8000),
    sameSchool() {
      this.$socket.connect();
      this.$socket.emit('school');
      //server will distinguish school by ip
    },
    socketInitial(channel) {
      this.$socket.connect();
      this.$socket.emit('channel', channel);
    },
    scrollMessageToBottom() {
      let content = document.querySelector('.content');
      this.$nextTick().then(() => {
        content.scrollTop = content.scrollHeight;
      });
    },
    ...mapActions('school', ['getSchoolInfo'])
  }
};
</script>
<style lang="scss" scoped>
.seesaw-enter-active {
  animation: seesaw-in 0.5s;
}
.seesaw-leave-active {
  animation: seesaw-in 0.5s reverse;
}
@keyframes seesaw-in {
  0% {
    opacity: 0;
  }
  25% {
    transform: rotate(7deg);
  }
  50% {
    opacity: 0.5;
    transform: rotate(-7deg);
  }
  75% {
    opacity: 0.75;
    transform: rotate(7deg);
  }
  100% {
    opacity: 1;
    transform: rotate(0deg);
  }
}
.social-media {
  text-decoration: none;
  color: #f96f87;
}
.message-img {
  max-width: 100%;
  border-radius: 3px;
}
.content {
  max-width: 700px;
  width: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  figure {
    text-align: center;
    margin: 20px;
  }
  .right {
    justify-content: flex-end;
  }
  .center {
    justify-content: center;
  }

  .content-inner {
    background-color: rgba(249, 249, 249, 0.4);
    margin: 10px 10px 0px 10px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  }

  #logo {
    border-radius: 20px;
    max-width: 100%;
  }
  h1.title {
    padding: 0 20px;
    letter-spacing: 4px;
    text-align: center;
    font-family: monospace, fantasy, Arial, Helvetica, sans-serif;
    font-size: 20px;
    transform: rotate(-2deg);
  }

  blockquote.quote {
    user-select: none;
    margin: 10px;
    padding: 10px;
    font-size: 18px;
    font-style: italic;
    line-height: 0.8em;
    opacity: 0.3;
    font-family: monospace, fantasy, Arial, Helvetica, sans-serif;
  }
  .footer {
    text-align: center;
    margin: 10px;
    font-size: 14px;
  }
  @media (max-width: 320px) {
    //For iPhone 5/5s/SE
    h1.title {
      font-size: 16px;
      font-weight: bold;
    }
    blockquote {
      font-size: 14px;
    }
    .footer {
      font-size: 12px;
    }
  }
  .button-parent {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    text-align: center;
    margin: 10px;

    & > button {
      outline: none;
      cursor: pointer;
      //width: 200px;
      text-align: center;
      padding: 20px 40px;
      //padding:10px 20px;
      margin: 10px;
      border-radius: 10px;
      background: none;
      font-size: 20px;
      border: 1px solid black;
      & > a {
        color: black;
        text-decoration: none;
      }
      & > a:visited {
        color: black;
      }
    }
    & > button:hover {
      color: red;
      border: 1px solid red;
    }
    & > .button-disabled {
      border-color: gray;
      color: gray;
    }
    & > .button-disabled:hover {
      color: gray;
      border-color: gray;
    }
  }
}
</style>
